
  export default {
    name: 'AppStorePreview'
  }
